import path from 'path';
export const isJsx = (pkg) => {
    if (pkg.source && path.extname(pkg.source).includes('sx'))
        return true;
    return (!!pkg.dependencies?.react ||
        !!pkg.devDependencies?.react ||
        !!pkg.peerDependencies?.react);
};
